module.exports = __webpack_public_path__ + "assets/箭头.8d74b8ae.svg";